import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        interval: Number,
        modals: Array,
        delay: { type: Number, default: 2000 },
    };

    connect() {
        this.STORAGE_KEY = 'promo_cycle_state';

        this._onModalClose = this.onModalClose.bind(this);
        document.addEventListener('modal:close', this._onModalClose);

        console.log('schedule and open')

        this.scheduleCycleOpen();
    }

    disconnect() {
        document.removeEventListener('modal:close', this._onModalClose);
    }

    scheduleCycleOpen() {
        setTimeout(() => this.checkAndOpen(), this.delayValue);
    }

    onModalClose(event) {
        const closedName = event.target?.dataset?.modalNameValue;

        if (!closedName || !this.modalsValue.includes(closedName)) return;

        const state = this.getState();
        state.lastClose = Date.now();
        this.saveState(state);
    }

    checkAndOpen() {
        const state      = this.getState();
        const now        = Date.now();
        const intervalMs = this.intervalValue * 60 * 60 * 1000;
        const modals     = this.getManagedModals();

        if (modals.length === 0) {
            return;
        }

        const shouldOpen = !state.lastClose || (now - state.lastClose >= intervalMs);

        if (!shouldOpen) return;

        const nextIndex    = state.index === -1 ? 0 : (state.index + 1) % modals.length;
        const modalElement = modals[nextIndex];

        modalElement.dispatchEvent(new CustomEvent('modal:open', { bubbles: true }));

        state.index = nextIndex;
        this.saveState(state);
    }

    getManagedModals() {
        return this.modalsValue
            .map(name => document.querySelector(`[data-modal-name-value="${name}"]`))
            .filter(Boolean);
    }

    getState() {
        try {
            return JSON.parse(localStorage.getItem(this.STORAGE_KEY)) || { index: -1, lastClose: 0 };
        } catch {
            return { index: -1, lastClose: 0 };
        }
    }

    saveState(state) {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
    }
}
